var _defs, _g, _g2, _circle, _path, _line, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetailOrbitLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 701 166.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #5558d4;\n      }\n\n      .st1 {\n        fill: #e77a35;\n      }\n\n      .st2 {\n        fill: none;\n        stroke: #f97215;\n        stroke-miterlimit: 10;\n        stroke-width: 1.8px;\n      }\n\n      .st3 {\n        fill: #2a2830;\n      }\n\n      .st4 {\n        fill: #3e4543;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.29,92.28l-17.78-26.55h-14.34v26.55H8.91V9.3h37.93c19.56,0,31.29,10.31,31.29,27.38v.24c0,13.39-7.23,21.81-17.78,25.72l20.27,29.63h-21.34ZM59.64,37.63c0-7.82-5.45-11.85-14.34-11.85h-18.13v23.83h18.49c8.89,0,13.99-4.74,13.99-11.73v-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.63,66.79h-44.21c1.78,8.18,7.47,12.45,15.53,12.45,6.05,0,10.43-1.9,15.41-6.52l10.31,9.13c-5.93,7.35-14.46,11.85-25.96,11.85-19.08,0-33.19-13.39-33.19-32.83v-.24c0-18.13,12.92-33.07,31.41-33.07,21.22,0,30.94,16.48,30.94,34.49v.24c0,1.78-.12,2.85-.24,4.5ZM113.93,42.02c-7.47,0-12.33,5.33-13.75,13.51h27.14c-1.07-8.06-5.81-13.51-13.39-13.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M173.79,93.34c-11.02,0-18.49-4.39-18.49-19.08v-30.11h-7.59v-15.41h7.59V12.5h18.02v16.24h14.93v15.41h-14.93v27.14c0,4.15,1.78,6.16,5.81,6.16,3.32,0,6.28-.83,8.89-2.25v14.46c-3.79,2.25-8.18,3.67-14.22,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M232.81,92.28v-6.88c-4.39,4.86-10.43,8.06-19.2,8.06-11.97,0-21.81-6.87-21.81-19.44v-.24c0-13.87,10.55-20.27,25.6-20.27,6.4,0,11.02,1.07,15.53,2.61v-1.07c0-7.47-4.62-11.62-13.63-11.62-6.88,0-11.73,1.3-17.54,3.44l-4.5-13.75c6.99-3.08,13.87-5.1,24.65-5.1,19.68,0,28.33,10.19,28.33,27.38v36.86h-17.42ZM233.17,66.67c-3.08-1.42-7.11-2.37-11.5-2.37-7.7,0-12.45,3.08-12.45,8.77v.24c0,4.86,4.03,7.7,9.84,7.7,8.42,0,14.1-4.62,14.1-11.14v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M260.67,92.28V28.74h18.02v63.53h-18.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M290.54,92.28V5.75h18.02v86.53h-18.02Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.06,93.7c-25.6,0-43.97-19.08-43.97-42.67v-.24c0-23.59,18.61-42.91,44.21-42.91s43.97,19.08,43.97,42.67v.24c0,23.59-18.61,42.91-44.21,42.91ZM384.19,50.79c0-14.22-10.43-26.08-25.13-26.08s-24.89,11.62-24.89,25.84v.24c0,14.22,10.43,26.08,25.13,26.08s24.89-11.62,24.89-25.84v-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.96,92.28l-17.78-26.55h-14.34v26.55h-18.25V9.3h37.93c19.56,0,31.29,10.31,31.29,27.38v.24c0,13.39-7.23,21.81-17.78,25.72l20.27,29.63h-21.34ZM464.31,37.63c0-7.82-5.45-11.85-14.34-11.85h-18.13v23.83h18.49c8.89,0,13.99-4.74,13.99-11.73v-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M532.83,92.28h-39.47V9.3h38.52c16.95,0,27.38,8.42,27.38,21.45v.24c0,9.36-4.98,14.58-10.91,17.9,9.6,3.67,15.53,9.25,15.53,20.39v.24c0,15.17-12.33,22.76-31.05,22.76ZM541.12,33.84c0-5.45-4.27-8.53-11.97-8.53h-18.02v17.54h16.83c8.06,0,13.16-2.61,13.16-8.77v-.24ZM545.75,67.03c0-5.57-4.15-9.01-13.51-9.01h-21.1v18.25h21.69c8.06,0,12.92-2.85,12.92-9.01v-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M573.84,92.28V9.3h18.25v82.97h-18.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M644.48,26.14v66.14h-18.25V26.14h-25.25V9.3h68.75v16.83h-25.25Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 269.29,
    cy: 13.42,
    r: 9.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M691.57,17.97c0,4.05-3.15,7.22-7.2,7.22s-7.16-3.17-7.16-7.18,3.11-7.18,7.2-7.18,7.16,3.09,7.16,7.14ZM690.61,17.97c0-3.54-2.62-6.22-6.2-6.22s-6.24,2.77-6.24,6.26,2.66,6.26,6.2,6.26,6.24-2.77,6.24-6.31ZM686.34,19.21l1.85,2.87h-1.4l-1.69-2.6h-2.22v2.6h-1.38v-8.14h3.25c2.03,0,3.29,1.08,3.29,2.77,0,1.24-.63,2.12-1.71,2.5ZM686.71,16.71c0-1.04-.75-1.61-2.05-1.61h-1.79v3.23h1.79c1.3,0,2.05-.59,2.05-1.63Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 9.5,
    y1: 112.4,
    x2: 645,
    y2: 112.4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.08,142.38c0,4.47-3.24,7.17-8.58,7.17h-5.64v6.63h-2.22v-21h7.86c5.34,0,8.58,2.7,8.58,7.2ZM23.86,142.38c0-3.36-2.22-5.28-6.42-5.28h-5.58v10.5h5.58c4.2,0,6.42-1.92,6.42-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M33.94,145.68c0-6.12,4.68-10.68,11.04-10.68s11.01,4.53,11.01,10.68-4.71,10.68-11.01,10.68-11.04-4.56-11.04-10.68ZM53.77,145.68c0-5.01-3.75-8.7-8.79-8.7s-8.85,3.69-8.85,8.7,3.78,8.7,8.85,8.7,8.79-3.69,8.79-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.79,135.18l-7.08,21h-2.34l-6.15-17.91-6.18,17.91h-2.31l-7.08-21h2.28l6.06,18.06,6.27-18.06h2.07l6.18,18.15,6.15-18.15h2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.31,154.26v1.92h-14.85v-21h14.4v1.92h-12.18v7.47h10.86v1.89h-10.86v7.8h12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.49,156.18l-4.8-6.75c-.54.06-1.08.09-1.68.09h-5.64v6.66h-2.22v-21h7.86c5.34,0,8.58,2.7,8.58,7.2,0,3.3-1.74,5.61-4.8,6.6l5.13,7.2h-2.43ZM141.37,142.38c0-3.36-2.22-5.28-6.42-5.28h-5.58v10.53h5.58c4.2,0,6.42-1.95,6.42-5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.31,154.26v1.92h-14.85v-21h14.4v1.92h-12.18v7.47h10.86v1.89h-10.86v7.8h12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M178.15,135.18h8.55c6.72,0,11.25,4.32,11.25,10.5s-4.53,10.5-11.25,10.5h-8.55v-21ZM186.58,154.26c5.58,0,9.18-3.54,9.18-8.58s-3.6-8.58-9.18-8.58h-6.21v17.16h6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M237.58,150.57c0,3.57-2.64,5.61-7.89,5.61h-9.66v-21h9.06c4.68,0,7.38,1.98,7.38,5.4,0,2.4-1.29,3.99-3.21,4.77,2.7.6,4.32,2.37,4.32,5.22ZM222.25,137.01v7.62h6.69c3.36,0,5.31-1.29,5.31-3.81s-1.95-3.81-5.31-3.81h-6.69ZM235.36,150.39c0-2.73-2.01-3.93-5.7-3.93h-7.41v7.89h7.41c3.69,0,5.7-1.2,5.7-3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M254.02,148.92v7.26h-2.19v-7.26l-8.4-13.74h2.37l7.2,11.79,7.2-11.79h2.22l-8.4,13.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M304.78,135.18v21h-2.13v-16.8l-8.25,14.13h-1.05l-8.25-14.04v16.71h-2.13v-21h1.83l9.12,15.57,9.03-15.57h1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.41,150.57h-11.7l-2.52,5.61h-2.31l9.6-21h2.19l9.6,21h-2.34l-2.52-5.61ZM328.6,148.77l-5.04-11.28-5.04,11.28h10.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M359.92,135.18v21h-1.83l-13.5-17.04v17.04h-2.22v-21h1.83l13.53,17.04v-17.04h2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M384.54,150.57h-11.7l-2.52,5.61h-2.31l9.6-21h2.19l9.6,21h-2.34l-2.52-5.61ZM383.74,148.77l-5.04-11.28-5.04,11.28h10.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M412,145.68h2.13v8.01c-1.98,1.77-4.8,2.67-7.71,2.67-6.39,0-11.07-4.53-11.07-10.68s4.68-10.68,11.1-10.68c3.18,0,5.94,1.02,7.8,3.03l-1.38,1.41c-1.77-1.74-3.87-2.46-6.33-2.46-5.19,0-9,3.69-9,8.7s3.81,8.7,8.97,8.7c2.01,0,3.87-.45,5.49-1.62v-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M439.87,154.26v1.92h-14.85v-21h14.4v1.92h-12.18v7.47h10.86v1.89h-10.86v7.8h12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M471.51,135.18v21h-2.13v-16.8l-8.25,14.13h-1.05l-8.25-14.04v16.71h-2.13v-21h1.83l9.12,15.57,9.03-15.57h1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M497.83,154.26v1.92h-14.85v-21h14.4v1.92h-12.18v7.47h10.86v1.89h-10.86v7.8h12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M525.21,135.18v21h-1.83l-13.5-17.04v17.04h-2.22v-21h1.83l13.53,17.04v-17.04h2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M540.75,137.1h-7.38v-1.92h16.98v1.92h-7.38v19.08h-2.22v-19.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M569.13,145.68c0-6.12,4.68-10.68,11.04-10.68s11.01,4.53,11.01,10.68-4.71,10.68-11.01,10.68-11.04-4.56-11.04-10.68ZM588.96,145.68c0-5.01-3.75-8.7-8.79-8.7s-8.85,3.69-8.85,8.7,3.78,8.7,8.85,8.7,8.79-3.69,8.79-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M618.33,135.18v21h-1.83l-13.5-17.04v17.04h-2.22v-21h1.83l13.53,17.04v-17.04h2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M644.64,154.26v1.92h-14.85v-21h14.4v1.92h-12.18v7.47h10.86v1.89h-10.86v7.8h12.63Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailOrbitLogo);
export default __webpack_public_path__ + "static/media/retail-orbit-logo.1cbcb02bb8dd154f768fdabad2062229.svg";
export { ForwardRef as ReactComponent };